import { IInvoicingConfigUpdateRequest } from "@wingspanhq/payments/dist/interfaces/api/invoicingConfig";
import { useWSMutation } from "../../helpers";
import { updateInvoicingConfig } from "../../../services/invoicingConfig";
import { QUERY_INVOICING_CONFIG_FOR_PAYER } from "../keys";

export const useMutationUpdateInvoicingConfig = () =>
  useWSMutation(
    (payload: IInvoicingConfigUpdateRequest) => updateInvoicingConfig(payload),
    {
      dependencies: [QUERY_INVOICING_CONFIG_FOR_PAYER]
    }
  );
